import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Nav, Tab } from 'react-bootstrap';

import Transactions from "./Transactions";
import ColumnHeader from "./ColumnHeader";
import Categories from "./Categories";
import Dollars from "./Dollars";
import apiClient from "../lib/apiClient";

export default function Account() {
  const { id } = useParams();
  const [account, setAccount] = useState(null);
  const location = useLocation().hash || "#cashflow";
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      apiClient.get(`/api/accounts/${id}`)
        .then(({ data }) => {
          document.title = data.name;
          setAccount(data);
        }).catch(console.error);
    }
  }, [id]);
  if (!id || !account) {
    return null;
  }

  return <div className="container mt-1 me-2">
    <Tab.Container activeKey={location} onSelect={(tab) => navigate(tab)}>
      <ColumnHeader title={account.name}
        subtitle={<>
          Last Four: {account.last_four} |
          Balance: <Dollars amount={account.balance} />
        </>}
      >
        <Nav variant="underline">
          <Nav.Item>
            <Nav.Link eventKey="#cashflow">Cashflow</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="#transactions">Transactions</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="#edit">Edit</Nav.Link>
          </Nav.Item>
        </Nav>
      </ColumnHeader>

      <Tab.Content>
        <Tab.Pane eventKey="#cashflow">
          <Categories accountId={id} />
        </Tab.Pane>
        <Tab.Pane eventKey="#transactions">
          <Transactions accountId={id} />
        </Tab.Pane>
        <Tab.Pane eventKey="#edit">
          <p>Edit to come...</p>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>

  </div>

}

